import { z } from 'zod';

import {
  LoanNoteContactRoleBorrower,
  LoanNoteContactRoleNonBorrower,
  LoanNoteContactType,
  LoanNoteTopic,
} from '../loan/LoanNotes';

export const LoanNoteApi = z.object({
  id: z.string(),
  loanId: z.string(),
  losId: z.string(),
  notes: z.array(
    z.object({
      id: z.string(),

      /**
       * @deprecated
       * userEmail is deprecated, use author instead
       */
      userEmail: z.string().optional().meta({ deprecated: true }),
      author: z.string().optional(),

      comment: z.string(),
      timestamp: z.iso.datetime(),
      createdAt: z.iso.datetime(),

      topics: z.array(LoanNoteTopic).optional(),
      contactType: LoanNoteContactType.optional(),
      contactRole: z.union([LoanNoteContactRoleNonBorrower, LoanNoteContactRoleBorrower]).optional(),
      borrowerName: z.string().optional(),
    }),
  ),
});
export type LoanNoteApi = z.infer<typeof LoanNoteApi>;
